/* eslint-disable */
import jQuery from 'jquery';

/* QUICK FIX NA LANGUAGE */
const Liferay = {
  Language: {
    get: (inp) => {
      return inp;
    },
  },
};

var PreviewClass = function ($) {
  var contentData;

  var config = {
    embedMode: false,
    embedPageName: 'embed',
    enableEmbedding: false,
    scriptsBasePath: '/assets/pano2vr/',
    cssBasePath: '/assets/pano2vr/',
    imagesBasePath: '/assets/pano2vr/',
    animationSpeed: 200,
    fullscreenClass: 'fullscreen',
    title: '',
    searchFunction: undefined,
    trackFunction: undefined,
    crossOriginPolicy: false,
    ajaxWithCredentials: false,
    loadTilesWithAjax: false,

    localization: {
      errorRenderingView: Liferay.Language.get('plugin.errorRenderingView'),
      loading: Liferay.Language.get('plugin.loading'),
      notFound: Liferay.Language.get('plugin.notFound'),
      changeSide: Liferay.Language.get('plugin.changeSide'),
      reset3D: Liferay.Language.get('plugin.reset3D'),
      showAll3D: Liferay.Language.get('plugin.showAll3D'),
      embedTitle: Liferay.Language.get('plugin.embedTitle'),
      rotateView: Liferay.Language.get('plugin.rotateView'),
      rotateObject: Liferay.Language.get('plugin.rotateObject'),
    },
    urlParameters: {
      page: 'page',
      contentId: 'content',
      contentDo: 'contentDo',
      track: 'track',
    },
    seadragonTemplate:
      '<header style="display: none;"></header>' +
      '<div style="position:relative;" class="openseadragon has-box-shadow"><div class="openseadragon-outer-container" ></div>' +
      '<aside class="photo-preview hidden-xs hidden-print">' +
      '<figure>' +
      '<div id="navigatorDiv" class="openseadragon-navigator"></div>' +
      '</figure>' +
      '<div class="thumbnail-control clearfix">' +
      '<span id="zoom-in" class="icon-16 icon-plus-white pull-left"  title="' +
      Liferay.Language.get('plugin.zoomin') +
      '"></span>' +
      '<div class="center-block">' +
      '<span id="zoom-home" class="icon-16 icon-center-white" title="' +
      Liferay.Language.get('plugin.center') +
      '"></span>' +
      '</div>' +
      '<span id="zoom-out" class="icon-16 icon-minus-white pull-right"  title="' +
      Liferay.Language.get('plugin.zoomout') +
      '"></span>' +
      '</div>' +
      '</aside>' +
      '<figure class="photo-thumbnails-holder hidden hidden-print">' +
      '<div class="photo-thumbnails-viewport">' +
      '</div>' +
      '</figure>' +
      '<div class="plugin-tool-box ko">' +
      '<span class="icon-30 icon-eye-white pull-left" style="display: none; margin-left: 0px;"></span>' +
      '<span id="toggle-chapters" style="display: none; margin-left: 0;" class="icon-30 icon-copy-white pull-left" style="margin-left: 0;"></span>' +
      '<span class="icon-30 icon-search-empty-white pull-left search-toggler" title="' +
      Liferay.Language.get('plugin.search') +
      '"></span>' +
      '<div class="center-block">' +
      '<span class="icon-30 icon-thumbs-white photos-more-toggle" style="display: none;" title="' +
      Liferay.Language.get('plugin.more') +
      '"></span>' +
      '<span id="previous-figure" style="display: none;" class="icon-30 icon-arrow-left-white" title="' +
      Liferay.Language.get('plugin.previous') +
      '"></span>' +
      '<span class="page-counter" style="display: none;"></span>' +
      '<span id="next-figure" style="display: none;" class="icon-30 icon-arrow-right-white" title="' +
      Liferay.Language.get('plugin.next') +
      '"></span>' +
      '</div>' +
      '<span class="icon-30 icon-extend-white pull-right ios-hidden"  title="' +
      Liferay.Language.get('plugin.fullscreen') +
      '"></span>' +
      '<span class="icon-30 icon-embed-white pull-right" title="' +
      Liferay.Language.get('plugin.embed') +
      '"></span>' +
      '</div></div>',
    seadragonChaptersTemplate:
      '<section id="chapters" class="chapter-section has-box-shadow" style="min-height: 500px; display: none; background: rgba(0,0,0,0.6); width: 555px;"><div class="container"></div></section>',
    panoramaTemplate: `
            <div class="panorama-navigator hidden-print">
                <div class="directions">
                    <a class="bi bi-caret-up button-up"></a>
                    <div class="mid">
                        <a class="bi bi-caret-left button-left"></a>
                        <a class="bi bi-caret-right button-right"></a>
                    </div>
                    <a class="bi bi-caret-down button-down"></a>
                </div>
                <div class="bottom">
                    <i id="zoom-in" class="bi bi-plus"></i>
                    <i id="zoom-home" class="bi bi-stop"></i>
                    <i id="zoom-out" class="bi bi-dash"></i>
                </div>
            </div>
            <div class="has-box-shadow">
                <div id="panorama-container" class="panorama-container"></div>
                <div class="plugin-tool-box ko hidden-print">
                    <div class="center-block">
                        <i class="bi bi-arrow-left-right toggle-side" style="display: none"></i>
                        <i class="bi bi-play-circle icon-rotation-white toggle-rotation" style="display: none"></i>
                    </div>
                    <i class="bi bi-fullscreen icon-extend-white"></i>
                    <i class="bi bi-fullscreen-exit icon-embed-white"></i>
                </div>
            </div>
        `,
    x3dTemplate:
      '<header></header>' +
      '<div class="x3d-navigator hidden-print">' +
      '<a id="x3d-examine" style="opacity: 1;"><span class="glyphicon glyphicon-screenshot" title="' +
      Liferay.Language.get('plugin.rotate') +
      '"></span><span class="caption">Otáčať objekt</span></a>' +
      '<a id="x3d-look-at"><span class="glyphicon glyphicon-move"></span><span class="caption">Otáčať celú scénu</span></a><hr />' +
      '<a id="view-everything" style="opacity: 1;"><span class="glyphicon glyphicon-eye-open" title="' +
      Liferay.Language.get('plugin.showWholeObject') +
      '"></span><span class="caption">Zobraziť celý objekt</span></a>' +
      '<a id="reset-view" style="opacity: 1;"><span class="glyphicon glyphicon-repeat" title="' +
      Liferay.Language.get('plugin.defaultView') +
      '"></span><span class="caption">Pôvodné zobrazenie</span></a>' +
      '</div><div style="position: relative; background: #666;" class="has-box-shadow">' +
      '<div class="x3d-container clearfix" style="min-height: 370px; background: #666666 !important;"></div>' +
      '<div class="plugin-tool-box ko">' +
      '<div class="center-block"></div>' +
      '<span class="icon-30 icon-extend-white pull-right ios-hidden" title="' +
      Liferay.Language.get('plugin.fullscreen') +
      '"></span><span class="icon-30 icon-embed-white pull-right" title="' +
      Liferay.Language.get('plugin.embed') +
      '"></span></div></div>',
    videoTemplate:
      '<figure class="has-player video clearfix">' +
      '<video id="videoplayer" preload="none" class="has-box-shadow pull-left" style="background-color: #666;">' +
      '</video>' +
      '<div class="subtitles"><div></div><div></div></div>' +
      '<div class="loader"><div /></div>' +
      '<div class="plugin-tool-box ko ios-hidden hidden-print" id="videocontrol" style="display: table-row;">' +
      '<span class="control-icon"><span id="play-button" class="icon icon-30 icon-play-white" title="' +
      Liferay.Language.get('plugin.playPause') +
      '"></span></span>' +
      '<span class="control-icon"><span id="current-time" class="uppercase white time">0:00</span></span>' +
      '<div class="center-block" style="padding-right: 12px;">' +
      '<progress min="0" max="100" value="0" id="playhead"></progress>' +
      '</div>' +
      '<span class="control-icon hidden-xs hidden-sm"><span id="volume-button" class="glyphicon glyphicon glyphicon-volume-up" title="' +
      Liferay.Language.get('plugin.volume') +
      '"></span>' +
      '<progress min="0" max="100" value="80" id="volume-control" style="top: 8px; left: 4px;"></progress></span>' +
      '<span class="control-icon"><span class="icon-30 icon-embed-white" title="' +
      Liferay.Language.get('plugin.embed') +
      '"></span></span>' +
      '<span class="control-icon"><span class="video-tools"></span></span>' +
      '<span class="control-icon"><span class="icon icon-30 fullscreen-button icon-extend-white" title="' +
      Liferay.Language.get('plugin.fullscreen') +
      '"></span></span>' +
      '<span style="display:none" id="statusStr" size = "" type="text" placeholder="" value=""></span>' +
      '</div></figure></span>',
    videoWowzaTemplate:
      '<figure class="has-player video clearfix"> <!-- HEADER -->' +
      '<video id="videoObj"   x-webkit-airplay="allow" controls="controls" class="has-box-shadow pull-left" style="background-color: #666;></video>' +
      '<table>' +
      '<tr>' +
      '<td align="right">' +
      '<b>Status:</b>' +
      '</td>' +
      '<td>' +
      '<label id="statusStr" size = "100" type="text" placeholder="" value="">Disconnected</label>' +
      '</td>' +
      '</tr>' +
      '</table>' +
      '</div>' +
      '</figure></span>',
    audioTemplate:
      '<figure class="has-player audio">' +
      '<img src="" class="has-box-shadow poster" alt="Image descr." style="display: none;" />' +
      '<div class="plugin-tool-box ko">' +
      '<figure id="audioplayer">' +
      '<div id="playback">' +
      '<span class="control-icon"><span id="play-button" class="icon icon-30 icon-play-white" title="' +
      Liferay.Language.get('plugin.playPause') +
      '"></span></span>' +
      '<span class="control-icon"><span id="current-time" class="uppercase white time">0:00</span></span>' +
      '<div class="center-block" style="padding-right: 12px;">' +
      '<progress min="0" max="100" value="0" id="playhead"></progress>' +
      '</div>' +
      '<span class="control-icon hidden-xs hidden-sm"><span id="volume-button" class="glyphicon glyphicon glyphicon-volume-up" title="' +
      Liferay.Language.get('plugin.volume') +
      '"></span>' +
      '<progress min="0" max="100" value="80" id="volume-control" style="top: 8px; left: 4px;"></progress></span>' +
      '<span class="control-icon"><span class="icon-30 icon-embed-white" title="' +
      Liferay.Language.get('plugin.embed') +
      '"></span></span>' +
      '</div><audio id="audiotrack" preload="auto"></audio></figure></div></figure><div id="embed-holder"></div><ul id="playlist"></ul>',
  };

  String.prototype.endsWith = function (suffix) {
    return this.indexOf(suffix, this.length - suffix.length) !== -1;
  };

  function guid() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }

    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
  }

  function addImageLoader($container, cImageSrc) {
    var cSpeed = 6;
    var cWidth = 60;
    var cHeight = 60;
    var cTotalFrames = 18;
    var cFrameWidth = 60;

    var cImageTimeout = false;
    var cIndex = 0;
    var cXpos = 0;
    var cPreloaderTimeout = false;
    var SECONDS_BETWEEN_FRAMES = 0;
    var container = $container.get(0);

    function startAnimation() {
      container.style.backgroundImage = 'url(' + cImageSrc + ')';
      container.style.width = cWidth + 'px';
      container.style.height = cHeight + 'px';
      //FPS = Math.round(100/(maxSpeed+2-speed));
      FPS = Math.round(100 / cSpeed);
      SECONDS_BETWEEN_FRAMES = 1 / FPS;
      cPreloaderTimeout = setTimeout(continueAnimation, SECONDS_BETWEEN_FRAMES / 1000);
    }

    function continueAnimation() {
      cXpos += cFrameWidth;
      //increase the index so we know which frame of our animation we are currently on
      cIndex += 1;
      //if our cIndex is higher than our total number of frames, we're at the end and should restart
      if (cIndex >= cTotalFrames) {
        cXpos = 0;
        cIndex = 0;
      }
      if (container) container.style.backgroundPosition = -cXpos + 'px 0';
      cPreloaderTimeout = setTimeout(continueAnimation, SECONDS_BETWEEN_FRAMES * 1000);
    }

    function stopAnimation() {
      //stops animation
      clearTimeout(cPreloaderTimeout);
      cPreloaderTimeout = false;
    }

    function imageLoader(s, fun) {
      //Pre-loads the sprites image
      clearTimeout(cImageTimeout);
      cImageTimeout = 0;
      genImage = new Image();
      genImage.onload = function () {
        cImageTimeout = setTimeout(fun, 0);
      };
      genImage.onerror = new Function("console.log('Could not load the image')");
      genImage.src = s;
    }

    //The following code starts the animation
    new imageLoader(cImageSrc, startAnimation);
  }

  function requestFullscreen(element) {
    $(element).find('.icon-extend-white').removeClass('icon-extend-white').addClass('icon-restore-white');
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.mozRequestFullScreen) {
      element.mozRequestFullScreen();
    } else if (element.webkitRequestFullscreen) {
      element.webkitRequestFullscreen();
    } else if (element.msRequestFullscreen) {
      element.msRequestFullscreen();
    } else {
      if (!config.embedMode) {
        $(element).removeClass(config.fullscreenClass);
      }
    }
  }

  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = 'expires=' + d.toUTCString();
    var path = 'path=' + location.pathname;
    document.cookie = cname + '=' + cvalue + '; ' + expires + '; ' + path;
  }

  function getCookie(cname) {
    var name = cname + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1);
      if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
    return '';
  }

  function getEmbedLink() {
    var url = window.location.href;
    var queryString = '';
    if (url.indexOf('?') > 0) {
      queryString = '?' + url.slice(url.indexOf('?') + 1);
    }
    return location.protocol + '//' + location.host + location.pathname + '/' + config.embedPageName + queryString;
  }

  function timedEvent(element, callback) {
    var intervalID;
    var intervalTime = 50;
    element
      .on('touchstart mousedown', function () {
        intervalID = setInterval(function () {
          callback();
        }, intervalTime);
      })
      .on('mouseup mouseout touchend', function () {
        clearInterval(intervalID);
      });
  }

  function simpleEvent(element, callback) {
    element.on('touchstart mousedown', function () {
      callback();
    });
  }

  function exitFullscreen(element) {
    $(element).find('.icon-restore-white').removeClass('icon-restore-white').addClass('icon-extend-white');
    if (document.cancelFullScreen) {
      document.cancelFullScreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    } else if (document.webkitCancelFullScreen) {
      document.webkitCancelFullScreen();
    } else {
      if (!config.embedMode) {
        $(element).removeClass(config.fullscreenClass);
      }
    }
  }

  function isInFullscreen() {
    var isInFullscreen = !(
      !document.fullscreenElement &&
      !document.msFullscreenElement &&
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    );
    return isInFullscreen;
  }

  var getScript = jQuery.getScript;
  jQuery.getScriptOrCss = function (resources, callback) {
    var // reference declaration &amp; localization
      length = resources.length,
      handler = function () {
        counter++;
      },
      deferreds = [],
      counter = 0,
      idx = 0;

    for (; idx < length; idx++) {
      var resource = resources[idx];
      if (resource.endsWith('js')) {
        deferreds.push(getScript(config.scriptsBasePath + resource, handler));
      }
      if (resource.endsWith('css')) {
        var head = document.getElementsByTagName('head')[0];
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.type = 'text/css';
        link.href = config.cssBasePath + resource;
        head.appendChild(link);
        handler();
      }
    }

    jQuery.when.apply(null, deferreds).then(function () {
      callback && callback();
    });
  };

  function loadScripts(urls, callback, condition) {
    if (condition || typeof condition === 'undefined') {
      console.debug('loading scripts: ' + urls);
      $.getScriptOrCss(urls, callback);
    } else {
      callback && callback();
    }
  }

  function getElementId(element) {
    if (element.attr('id')) {
      return element.attr('id');
    } else {
      var generatedId = 'slovakiana-preview-' + Math.floor(Math.random() * 10000 + 1);
      element.attr('id', generatedId);
      return generatedId;
    }
  }

  function queryParameter(key) {
    key = key.replace(/[*+?^$.\[\]{}()|\\\/]/g, '\\$&');
    var match = location.search.match(new RegExp('[?&]' + key + '=([^&]+)(&|$)'));
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
  }

  function rebindFullscreenEvents(callback) {
    document.removeEventListener('fullscreenchange', callback, false);
    document.removeEventListener('webkitfullscreenchange', callback, false);
    document.removeEventListener('mozfullscreenchange', callback, false);
    document.removeEventListener('MSFullscreenChange', callback, false);
    document.addEventListener('fullscreenchange', callback, false);
    document.addEventListener('webkitfullscreenchange', callback, false);
    document.addEventListener('mozfullscreenchange', callback, false);
    document.addEventListener('MSFullscreenChange', callback, false);
  }

  function toggleFullscreenClass(container) {
    if (isInFullscreen()) {
      $(container).addClass(config.fullscreenClass);
      $(container).find('.icon-extend-white').removeClass('icon-extend-white').addClass('icon-restore-white');
    } else {
      if (!config.embedMode) {
        $(container).removeClass(config.fullscreenClass);
      }
      $(container).find('.icon-restore-white').removeClass('icon-restore-white').addClass('icon-extend-white');
    }
  }

  function updateQueryStringParameter(uri, key, value) {
    var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
    var separator = uri.indexOf('?') !== -1 ? '&' : '?';
    if (uri.match(re)) {
      return uri.replace(re, '$1' + key + '=' + value + '$2');
    } else {
      return uri + separator + key + '=' + value;
    }
  }

  function addLoader(container, text) {
    removeLoader(container);
    if (!text) {
      text = config.localization.loading;
    }
    var $loader = $("<div id='preview-loader' style='display: none;background:#666;opacity:0.7;'>" + text + '</div>');
    $(container).append($loader);
    $loader.fadeIn('fast');
  }

  function removeLoader(container, timeout) {
    var $loader = $(container).find('#preview-loader');
    if (timeout != undefined && timeout > 0) {
      $loader.delay(timeout).fadeOut('fast', function () {
        $loader.remove();
      });
    } else {
      $loader.fadeOut('fast', function () {
        $loader.remove();
      });
    }
  }

  function changeLoaderText(container, text) {
    var $loader = $(container).find('#preview-loader');
    $loader.html(text);
  }

  function removeQueryStringParameter(url, parameter) {
    // prefer to use l.search if you have a location/link object
    var urlparts = url.split('?');
    if (urlparts.length >= 2) {
      var prefix = encodeURIComponent(parameter) + '=';
      var pars = urlparts[1].split(/[&;]/g);

      // reverse iteration as may be destructive
      for (var i = pars.length; i-- > 0; ) {
        // idiom for string.startsWith
        if (pars[i].lastIndexOf(prefix, 0) !== -1) {
          pars.splice(i, 1);
        }
      }
      if (pars.length == 0) {
        url = urlparts[0];
      } else {
        url = urlparts[0] + '?' + pars.join('&');
      }
      return url;
    } else {
      return url;
    }
  }

  function setParameter(name, value, saveState) {
    var url = updateQueryStringParameter(window.location.href, name, value);
    if (saveState) {
      history.pushState(
        {
          content: contentData,
        },
        null,
        url
      );
    } else {
      history.replaceState(
        {
          content: contentData,
        },
        null,
        url
      );
    }
  }

  function setParameters(params, saveState) {
    var url = window.location.href;
    for (var name in params) {
      var value = params[name];
      url = updateQueryStringParameter(url, name, value);
    }
    if (saveState) {
      history.pushState(
        {
          content: contentData,
        },
        null,
        url
      );
    } else {
      history.replaceState(
        {
          content: contentData,
        },
        null,
        url
      );
    }
  }

  function getParameter(name, defaultValue) {
    if (!defaultValue) {
      defaultValue = '';
    }
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
      results = regex.exec(location.search);
    return results === null ? defaultValue : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }

  function removeParameter(name) {
    var url = removeQueryStringParameter(window.location.href, name);
    history.replaceState(
      {
        content: contentData,
      },
      null,
      url
    );
  }

  function removeQueryString(keepParams, keepEmpty) {
    var paramValue = [];
    for (i = 0; i < keepParams.length; i++) {
      paramValue[i] = getParameter(keepParams[i]);
    }
    var url = window.location.href;
    var cleanUrl = url.split('?')[0].split('#')[0];
    history.replaceState(
      {
        content: contentData,
      },
      null,
      cleanUrl
    );

    var keepParamsPostProcessed = {};
    for (i = 0; i < keepParams.length; i++) {
      if (paramValue[i] != '' || keepEmpty) {
        keepParamsPostProcessed[keepParams[i]] = paramValue[i].replace(' ', '+');
      }
    }
    setParameters(keepParamsPostProcessed, false);
  }

  function timeFormat(sec_num) {
    var hours = Math.floor(sec_num / 3600);
    var minutes = Math.floor(sec_num / 60);
    var seconds = Math.round(sec_num - minutes * 60);

    if (seconds < 10) {
      seconds = '0' + seconds;
    }
    var time = minutes + ':' + seconds;
    return time;
  }

  function createEmbedPanel($container, embedURL, width, height) {
    var $embedPanel = $("<div class='embed-panel has-box-shadow'/>");
    if ($container.find('#embed-holder').length == 1) {
      $container.find('#embed-holder').append($embedPanel);
    } else {
      $container.append($embedPanel);
    }
    if (!width) {
      width = 560;
    }
    if (!height) {
      height = 315;
    }
    $embedPanel.append($("<div class='embed-title' />").text(config.localization.embedTitle));
    $embedPanel.append(
      $('<div class="embed-code" />').append(
        $('<textarea readonly="true" spellcheck="false" rows="3"/>')
          .click(function () {
            $(this).select();
            //$(this).copy();
          })
          .text(
            '<iframe width="' +
              width +
              '" height="' +
              height +
              '" src="' +
              embedURL +
              '" frameborder="0" allowfullscreen></iframe>'
          )
      )
    );
    $embedPanel.find('textarea').parent().append($('<a />').text('Kopírovať'));
    var $embedLink = $container.find('.icon-embed-white');
    $embedLink.click(function () {
      if ($embedPanel.hasClass('opened')) {
        $embedPanel.slideUp('fast').removeClass('opened');
      } else {
        $embedPanel.slideDown('fast', function () {}).addClass('opened');
      }
    });
  }

  function createSharePanel($container, embedURL) {
    var shareLinks =
      '<div class="social"><a href="#" class="has-icon-30 share-social fb-gray"></a><a href="#" class="has-icon-30 share-social tw-gray"></a><a href="#" class="has-icon-30 share-social pinterest-gray"></a><a href="#" class="has-icon-30 share-social gplus-gray"></a><a href="#" class="has-icon-30 share-social email-gray"></a></div>';
    var $embedPanel = $(
      "<div class='embed-panel has-box-shadow' style='display: none;'><a class='tab-title selected' id='share-tab-link'>Zdieľať</a><a class='tab-title' id='embed-tab-link'>Vložiť</a><div id='share-tab' class='tab'><input type='text' value='" +
        embedURL +
        "'  spellcheck='false' />" +
        shareLinks +
        "</div><div class='tab' id='embed-tab' style='display: none;'><textarea spellcheck='false'></textarea><div></div>"
    );
    $embedPanel
      .find('textarea')
      .text('<iframe width="560" height="315" src="' + embedURL + '" frameborder="0" allowfullscreen></iframe>');
    if ($container.find('#embed-holder').length == 1) {
      $container.find('#embed-holder').append($embedPanel);
    } else {
      $container.append($embedPanel);
    }
    if (typeof bindShareLinks == 'function') {
      bindShareLinks($embedPanel, getEmbedLink());
    }
    var $embedLink = $container.find('.icon-embed-white');
    var $shareLinks = $(
      '<div><a href="#" class="has-icon-30 share-social fb-gray"></a><a href="#" class="has-icon-30 share-social tw-gray"></a><a href="#" class="has-icon-30 share-social pinterest-gray"></a><a href="#" class="has-icon-30 share-social gplus-gray"></a><a href="#" class="has-icon-30 share-social email-gray"></a></div>'
    );
    $embedLink.click(function () {
      if ($embedPanel.hasClass('opened')) {
        $embedPanel.find('.social a').hide();
        $embedPanel.slideUp('fast').removeClass('opened');
      } else {
        $embedPanel
          .slideDown('fast', function () {
            $embedPanel.find('.social a').fadeIn('fast');
          })
          .addClass('opened');
      }
    });

    var $embedTabLink = $embedPanel.find('#embed-tab-link');
    var $shareTabLink = $embedPanel.find('#share-tab-link');
    $embedPanel.find('.tab-title').click(function () {
      $embedPanel.find('.tab-title').removeClass('selected');
      $(this).addClass('selected');
    });
    $embedTabLink.click(function () {
      $embedPanel.find('.tab').hide();
      $embedPanel.find('#embed-tab').show();
    });
    $shareTabLink.click(function () {
      $embedPanel.find('.tab').hide();
      $embedPanel.find('#share-tab').show();
    });
  }

  // hide preview controls during inactivity
  function hidePreviewControls($container, $toolbox, $topRightPreview) {
    var toolboxMoveTimeout;
    $container.on('mousemove touchend', function () {
      $toolbox.slideDown(config.animationSpeed);
      $topRightPreview.fadeIn();

      clearTimeout(toolboxMoveTimeout);
      toolboxMoveTimeout = setTimeout(function () {
        $toolbox.slideUp(config.animationSpeed);
        $topRightPreview.fadeOut();
      }, 3000);
    });
  }

  var VideoPreview = function (container) {
    var $container = $(config.container),
      $currentTime,
      video,
      storedVolume;
    var quality = {
      labels: [],
      values: [],
    };

    var subtitles = {
      labels: [],
      values: [],
    };
    var currentTrack;

    var ffCueTest;

    function cueChange(track, fn) {
      var supportTestTrack = video.textTracks[0];
      if (supportTestTrack.oncuechange !== undefined) {
        if (track) {
          track.oncuechange = fn;
        } else {
          fn();
        }
      }
      // Firefox doesn't support oncuechange
      if (supportTestTrack.oncuechange === undefined) {
        if (!track) {
          video.ontimeupdate = function () {};
          fn();
          return;
        }
        video.ontimeupdate = function () {
          var cue = track.activeCues[0];
          if (ffCueTest != cue) {
            fn();
          }
          ffCueTest = cue;
        };
      }
    }

    function selectTrack(track) {
      var span1 = $container.find('.subtitles div').first().get(0);
      var span2 = $container.find('.subtitles div').last().get(0);
      // deselect track (no subtitles)
      if (!track) {
        if (!currentTrack) {
          return;
        }
        span1.classList.remove('on');
        span2.classList.remove('on');
        cueChange(currentTrack, function () {});
        return;
      }
      // turn off current subtitles (if selected)
      if (currentTrack) {
        cueChange(currentTrack, function () {});
      }
      currentTrack = track;
      video = $container.find('video').get(0);
      for (i = 0; i < video.textTracks.length; i++) {
        video.textTracks[i].mode = 'hidden';
      }
      var idx = 0;
      cueChange(track, function () {
        var cue;
        if (track) {
          cue = track.activeCues[0];
        }
        if (cue) {
          if (idx == 0) {
            span2.className = '';
            span1.classList.remove('on');
            span1.innerHTML = '';
            span1.appendChild(cue.getCueAsHTML());
            span1.classList.add('on');
          } else {
            span1.className = '';
            span2.classList.remove('on');
            span2.innerHTML = '';
            span2.appendChild(cue.getCueAsHTML());
            span2.classList.add('on');
          }

          idx = ++idx % 2;
        } else {
          span1.classList.remove('on');
          span2.classList.remove('on');
        }
      });
    }

    function addMenuItem(iconClass, values, data, selectedValue, clickHandler) {
      var $toolbarHolder = $container.find('.video-tools');
      var $icon = $("<span class='toolbaritem' />").addClass(iconClass);
      var selectedClass = 'selected';
      $toolbarHolder.append($icon);

      var $menu = $("<ul class='video-menu' />");

      for (i = 0; i < values.length; i++) {
        var $menuItem = $('<li />');
        $menuItem.append($("<span class='glyphicon glyphicon-triangle-right'></span>"));
        $menuItem.append(values[i]);
        if (data) {
          $menuItem.attr('data-value', data[i]);
          if (data[i] === selectedValue) {
            $menuItem.addClass(selectedClass);
          }
        } else {
          if (values[i] === selectedValue) {
            $menuItem.addClass(selectedClass);
          }
        }

        $menu.append($menuItem);
        $menuItem.click(function () {
          $menu.slideUp(config.animationSpeed);
          $menu.find('li').removeClass(selectedClass);
          $(this).addClass(selectedClass);
          if (clickHandler) {
            clickHandler($(this));
          }
        });
      }

      container.find('.video').append($menu);
      //container.find('.plugin-tool-box .center-block').css({right: (260 + ($toolbarHolder.find(".toolbaritem").length * 15)) + "px"});
      function getRightPosition() {
        var rightPos = $container.width() - $icon.position().left - $menu.width();
        if (rightPos < 10) {
          return 10;
        }
        return rightPos;
      }

      $icon.click(function () {
        $menu.css({ right: getRightPosition() + 'px' });
        $container.find('.video-menu').not($menu).slideUp(config.animationSpeed);
        $menu.slideToggle(config.animationSpeed);
      });
    }

    return {
      render: function (callback) {
        $container.html(config.videoTemplate);
        addImageLoader($(container).find('.loader > div'), config.imagesBasePath + 'loaders/loader-sprites.png');
        video = $container.find('video').get(0);
        $currentTime = $container.find('#current-time');

        rebindFullscreenEvents(function () {
          toggleFullscreenClass($container);
        });

        if ($('#krpanoSWFObject').height() == screen.height) {
          // background virtual excursion is in fullscreen
          $container.find('.icon-extend-white').hide();
          $('#videocontrol').removeClass('ios-hidden');
        } else if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
          $('video').attr('controls', true);
        } else {
          // bind fullscreen events
          $container.find('.icon-extend-white').click(function () {
            if (!isInFullscreen()) {
              requestFullscreen($container.get(0));
            } else {
              exitFullscreen($container.get(0));
            }
          });
        }

        var seekBar = $container.find('#playhead').get(0);
        var volumeBar = $container.find('#volume-control').get(0);

        $container.find('#play-button').click(function () {
          if (video.paused) {
            $(this).removeClass('icon-play-white').addClass('icon-pause-white');
            video.play();
          } else {
            $(this).removeClass('icon-pause-white').addClass('icon-play-white');
            video.pause();
          }
        });
        video.addEventListener('ended', function () {
          $container.find('#play-button').removeClass('icon-pause-white').addClass('icon-play-white');
        });
        $(container)
          .find('#volume-button')
          .click(function () {
            if (!video.muted) {
              $(this).removeClass('glyphicon-volume-up').addClass('glyphicon-volume-off');
              storedVolume = $(volumeBar).val();
              $(volumeBar).val(0);
            } else {
              $(this).removeClass('glyphicon-volume-off').addClass('glyphicon-volume-up');
              $(volumeBar).val(storedVolume);
            }
            video.muted = !video.muted;
          });

        // volumebar event handling
        var volumemousebutton = 0;
        $(volumeBar).on('mousedown', function (e) {
          volumemousebutton = e.which;
        });
        $(volumeBar).on('mouseup', function (e) {
          volumemousebutton = 0;
        });
        $(volumeBar).on('click', function (e) {
          updateVolumeBar(e, this);
        });
        $(volumeBar).on('mousemove', function (e) {
          if (volumemousebutton == 1) {
            updateVolumeBar(e, this);
          }
        });
        function updateVolumeBar(event, element) {
          var offsetX = event.offsetX || event.pageX - $(event.target).offset().left;
          var value = Math.round((offsetX * 100) / $(element).width());
          $(volumeBar).val(value);
          video.volume = value / 100;
        }

        $(seekBar).on('change', function () {
          var time = video.duration * (this.value / 100);
          video.currentTime = time;
        });
        // seekbar event handling
        var mousebutton = 0;
        $(seekBar).on('mousedown', function (e) {
          mousebutton = e.which;
        });
        $(seekBar).on('mouseup', function (e) {
          mousebutton = 0;
        });
        $(seekBar).on('click', function (e) {
          updateSeekBar(e, this);
        });
        $(seekBar).on('mousemove', function (e) {
          if (mousebutton == 1) {
            updateSeekBar(e, this);
          }
        });

        $(video).click(function () {
          $container.find('#play-button').click();
        });

        $(video).dblclick(function () {
          $container.find('.fullscreen-button').click();
        });

        // autohiding of video toolbox
        var $toolbox = $container.find('#videocontrol');
        var videoMoveTimeout;
        $container.on('mousemove touchend', function () {
          $toolbox.slideDown(config.animationSpeed);
          clearTimeout(videoMoveTimeout);
          videoMoveTimeout = setTimeout(function () {
            $toolbox.slideUp(config.animationSpeed);
          }, 3000);
        });

        function updateSeekBar(event, element) {
          var offsetX = event.offsetX || event.pageX - $(event.target).offset().left;
          var value = Math.round((offsetX * 100) / $(element).width());
          $(seekBar).val(value);
          video.currentTime = video.duration * (value / 100);
        }

        video.addEventListener('timeupdate', function () {
          var value = (100 / video.duration) * video.currentTime;
          this.value = value;
          $(seekBar).val(value);
          $currentTime.text(timeFormat(video.currentTime));
        });
        video.addEventListener('loadeddata', function () {
          $currentTime.text(timeFormat(video.duration));
        });

        callback && callback();
      },

      load: function (data) {
        //test and get wowza url
        function getWowzaUrl(sources) {
          if (typeof wowzaServers == 'undefined') {
            return false;
          }

          wowzaServersArray = wowzaServers.split(';');

          for (i = 0; i < sources.length; i++) {
            var url = sources[i].url;
            url.replace('http://');
            url.replace('https://');
            for (j = 0; j < wowzaServersArray.length; j++) {
              // idiom for string.startsWith, url.startsWith(wowzaServersArray[j])
              if (url.lastIndexOf(wowzaServersArray[j], 0) !== -1) {
                return sources[i].url;
              }
            }
          }

          return false;
        }

        if (getWowzaUrl(data.videos[0].sources)) {
          var videoUrlWowza = getWowzaUrl(data.videos[0].sources);
          video = $container.find('video').get(0);

          function supports_media_source() {
            'use strict';
            var hasWebKit = window.WebKitMediaSource !== null && window.WebKitMediaSource !== undefined,
              hasMediaSource = window.MediaSource !== null && window.MediaSource !== undefined;
            return hasWebKit || hasMediaSource;
          }

          var video;
          var player;
          var source;
          var estimator;

          connect();

          function connect() {
            textContent = 'Stop';
            statusStr.textContent = 'Playing';
            if (video == null) {
              video = document.querySelector('video');
            }

            if (player == null) {
              player = new shaka.player.Player(video);
            }

            // Attach the player to the window so that it can be easily debugged.
            window.player = player;

            // Listen for errors from the Player.
            player.addEventListener('error', failed);

            // Construct a DashVideoSource to represent the DASH manifest.
            //var mpdUrl = 'http://turtle-tube.appspot.com/t/t2/dash.mpd';
            if (estimator != null) {
              estimator = null;
            }
            estimator = new shaka.util.EWMABandwidthEstimator();

            if (source != null) {
              source = null;
            }
            source = new shaka.player.DashVideoSource(videoUrlWowza, null, estimator);

            // Load the source into the Player.
            player.load(source);
          }

          function failed(e) {
            var done = false;
            if (e.detail == 'Error: Network failure.') {
              statusStr.textContent = 'Network Connection Failed.';
              statusStr.display(true);
              done = true;
            }
            if (e.detail.status != 200 && done == false) {
              switch (e.detail.status) {
                case 404:
                  statusStr.textContent = e.detail.url + ' not found.';
                  statusStr.display(true);
                  break;
                default:
                  statusStr.textContent = 'Error ' + e.detail.status + ' for ' + e.detail.url;
                  statusStr.display(true);
                  break;
              }
            }
          }

          function dashStop() {
            if (player != null) {
              player.unload();
            }
            statusStr.textContent = 'Disconnected';
          }

          connect();
        }
        video = $container.find('video').get(0);

        var videoData = data.videos[0];
        video.volume = 0.8;

        function setSources(sources) {
          var currentTime = video.currentTime;
          var videoPaused = video.paused;
          if (!videoPaused) {
            video.pause();
          }
          $(video).find('source').remove();
          for (i = 0; i < sources.length; i++) {
            var $sourceElem = $('<source />');
            $sourceElem.attr('src', sources[i].url);
            $sourceElem.attr('type', sources[i].mimeType);
            $(video).append($sourceElem);
          }
          video.load();
          //video.currentTime = currentTime;
          if (!videoPaused) {
            video.play();
          }
        }

        if (data.thumbnail && data.thumbnail.url) {
          $(video).attr('poster', data.thumbnail.url);
        }

        if (config.enableEmbedding) {
          createEmbedPanel(
            $container,
            getEmbedLink(),
            videoData.clientWidth,
            videoData.clientHeight - 105 /** odpocitam bulharsku konstantu 105 pixelov **/
          );
        } else {
          var $embedLink = $container.find('.icon-embed-white');
          $embedLink.hide();
        }

        setSources(videoData.sources);
        for (i = 0; i < data.videos.length; i++) {
          var eachVideo = data.videos[i];
          quality.labels.push(eachVideo.width + 'x' + eachVideo.height);
          quality.values.push(eachVideo.sources);
        }
        if (!data.subtitles) {
          data.subtitles = [];
        }
        for (i = 0; i < data.subtitles.length; i++) {
          var sub = data.subtitles[i];
          var subTrack = $("<track kind='subtitles' />")
            .attr('label', sub.alt)
            .attr('srclang', 'en')
            .attr('src', sub.url);

          subtitles.labels.push(sub.alt);
          subtitles.values.push(sub.lang);

          $(video).append(subTrack);
        }
        subtitles.labels.push('Bez titulkov');
        subtitles.values.push('empty');

        if (quality.values.length > 1) {
          addMenuItem('glyphicon glyphicon-cog', quality.labels, quality.labels, quality.labels[0], function ($elem) {
            setSources(quality.values[quality.labels.indexOf($elem.data('value'))]);
          });
        }

        if (subtitles.values.length > 1) {
          addMenuItem(
            'glyphicon glyphicon-subtitles',
            subtitles.labels,
            subtitles.values,
            subtitles.values[0],
            function ($elem) {
              selectTrack(findTrack($elem.data('value')));
            }
          );
        }

        function findTrack(lang) {
          for (i = 0; i < video.textTracks.length; i++) {
            if (video.textTracks[i].language === lang) {
              return video.textTracks[i];
            }
          }
        }

        var defaultTrackPreseleced = false;
        video.addEventListener(
          'loadeddata',
          function () {
            $container.find('.loader').fadeOut(config.animationSpeed);
            if (!defaultTrackPreseleced) {
              selectTrack(video.textTracks[0]);
              defaultTrackPreseleced = true;
            }
          },
          false
        );
        video.addEventListener(
          'loadstart',
          function () {
            container.find('.loader').fadeIn(config.animationSpeed);
          },
          false
        );
      },
    };
  };

  var AudioPreview = function (container) {
    var $container = $(config.container);
    var $audio, audio;
    var storedVolume;
    var seekBar;
    return {
      render: function (callback) {
        //loadScripts([ "audio-visualizer.js" ], load, typeof Visualizer === "undefined");

        //function load() {
        $container.html(config.audioTemplate);
        $audio = $container.find('audio');
        audio = $audio.get(0);

        // embed panel
        if (config.enableEmbedding) {
          createEmbedPanel($container, getEmbedLink());
        } else {
          var $embedLink = $container.find('.icon-embed-white');
          $embedLink.hide();
        }

        $currentTime = $container.find('#current-time');
        seekBar = $container.find('#playhead').get(0);
        var volumeBar = $container.find('#volume-control').get(0);
        //var visualizer = new Visualizer(audio);
        //visualizer.init();
        $container.find('#play-button').click(function () {
          if (audio.paused) {
            $(this).removeClass('icon-play-white').addClass('icon-pause-white');
            audio.play();
            //visualizer.play();
            /*if (visualizer.isSupported()) {
                         $container.find(".poster").fadeOut(config.animationSpeed, function() {
                         $container.find("#visualizer-wrapper").fadeIn(config.animationSpeed);
                         });
                         }*/
          } else {
            $(this).removeClass('icon-pause-white').addClass('icon-play-white');
            //visualizer.pause();
            audio.pause();
          }
        });

        audio.addEventListener('ended', function () {
          $container.find('#play-button').removeClass('icon-pause-white').addClass('icon-play-white');
          //visualizer.pause();
          //visualizer.init(audio);
        });
        $(container)
          .find('#volume-button')
          .click(function () {
            if (!audio.muted) {
              $(this).removeClass('glyphicon-volume-up').addClass('glyphicon-volume-off');
              storedVolume = $(volumeBar).val();
              $(volumeBar).val(0);
            } else {
              $(this).removeClass('glyphicon-volume-off').addClass('glyphicon-volume-up');
              $(volumeBar).val(storedVolume);
            }
            audio.muted = !audio.muted;
          });

        // volumebar event handling
        var volumemousebutton = 0;
        $(volumeBar).on('mousedown', function (e) {
          volumemousebutton = e.which;
        });
        $(volumeBar).on('mouseup', function (e) {
          volumemousebutton = 0;
        });
        $(volumeBar).on('click', function (e) {
          updateVolumeBar(e, this);
        });
        $(volumeBar).on('mousemove', function (e) {
          if (volumemousebutton == 1) {
            updateVolumeBar(e, this);
          }
        });
        function updateVolumeBar(event, element) {
          var offsetX = event.offsetX || event.pageX - $(event.target).offset().left;
          var value = Math.round((offsetX * 100) / $(element).width());
          $(volumeBar).val(value);
          audio.volume = value / 100;
        }

        $(seekBar).on('change', function () {
          var time = audio.duration * (this.value / 100);
          audio.currentTime = time;
        });

        // seekbar event handling
        var mousebutton = 0;
        $(seekBar).on('mousedown', function (e) {
          mousebutton = e.which;
        });
        $(seekBar).on('mouseup', function (e) {
          mousebutton = 0;
        });
        $(seekBar).on('click', function (e) {
          updateSeekBar(e, this);
        });
        $(seekBar).on('mousemove', function (e) {
          if (mousebutton == 1) {
            updateSeekBar(e, this);
          }
        });

        var $toolbox = $container.find('.plugin-tool-box');
        var videoMoveTimeout;
        $container.mousemove(function () {
          $toolbox.slideDown(config.animationSpeed);
          if (!video.paused) {
            clearTimeout(videoMoveTimeout);
            videoMoveTimeout = setTimeout(function () {
              $toolbox.slideUp(config.animationSpeed);
            }, 3000);
          }
        });

        function updateSeekBar(event, element) {
          var offsetX = event.offsetX || event.pageX - $(event.target).offset().left;
          var value = Math.round((offsetX * 100) / $(element).width());
          $(seekBar).val(value);
          audio.currentTime = audio.duration * (value / 100);
          //visualizer = new Visualizer(audio);
          //visualizer.init(currentTime);
          //visualizer.seek(audio.currentTime);
        }

        audio.addEventListener('timeupdate', function () {
          var value = (100 / audio.duration) * audio.currentTime;
          if (!isNaN(value)) {
            this.value = value;
            $(seekBar).val(value);
            $currentTime.text(timeFormat(audio.currentTime));
          }
        });

        audio.addEventListener('loadeddata', function () {
          if (!isNaN(audio.duration)) {
            $currentTime.text(timeFormat(audio.duration));
          }
        });

        callback && callback();
        //}
      },

      load: function (data) {
        var firstTrack = data.sources[getSelectedTrack() - 1];
        var playlist = $container.find('#playlist');
        var player = this;
        var $poster = $container.find('.poster');
        $poster.attr('src', firstTrack.thumbnail.url).fadeIn('fast');
        addSources(firstTrack.files);
        // show track list when contains two or more tracks
        if (data.sources.length > 1) {
          for (i = 0; i < data.sources.length; i++) {
            var track = data.sources[i];
            renderAudioTrack(i, track);
          }
          markTrackSelected('audio-track-' + getSelectedTrack());
        }

        function renderAudioTrack(index, track) {
          var name = index + 1 + '. ' + track.title;
          var duration = timeFormat(track.duration);
          var trackId = 'audio-track-' + (index + 1);
          var trackElement = $('<li />')
            .attr('id', trackId)
            .html(
              name +
                '<span class="icon icon-16 icon-play-gray pull-right"></span><span class="track-length pull-right">' +
                duration +
                '</span>'
            );
          $(trackElement).click(function () {
            setParameter('track', index + 1);
            player.render();
            player.load(data);
            markTrackSelected(trackId);
            $container.find('#play-button').click();
          });
          playlist.append(trackElement);
        }

        function markTrackSelected(trackId) {
          var $selection = $(container.find('#' + trackId));
          $selection.css({
            'font-weight': 'bold',
            color: 'black',
          });
        }

        function addSources(files) {
          for (i = 0; i < firstTrack.files.length; i++) {
            var file = files[i];
            $source = $('<source />').attr('src', file.url).attr('type', file.mimeType);
            $audio.append($source);
          }
        }

        function getSelectedTrack() {
          var selectedTrack = getParameter(config.urlParameters.track);
          if (!isNaN(parseInt(selectedTrack)) && selectedTrack <= data.sources.length && selectedTrack > 0) {
            return selectedTrack;
          }
          return 1;
        }
      },
    };
  };

  var OpenSeaDragonPreview = function (container, searchable, isBook) {
    var $container = $(config.container);
    var currentSearchResult = [],
      currentSearchIndex = 0,
      nextDirection = true,
      currentQuery = '';

    return {
      render: function (callback) {
        $container.html(config.seadragonTemplate);
        $container.find('.openseadragon').append(config.seadragonChaptersTemplate);
        addLoader($container);
        rebindFullscreenEvents(function () {
          toggleFullscreenClass($container);
        });
        // embed panel
        if (config.enableEmbedding) {
          createEmbedPanel($container, getEmbedLink());
        } else {
          var $embedLink = $container.find('.icon-embed-white');
          $embedLink.hide();
        }

        if (config.searchFunction && searchable) {
          $container.append(
            $(
              "<div class='search-bar'>" +
                "<input type='text' /><span class='search-button search-bar-button'>Hľadať</span>" +
                "<span class='search-bar-button search-prev'><span class='icon-16 icon-arrow-left-white'></span></span>" +
                "<span class='search-bar-button search-next'><span class='icon-16 icon-arrow-right-white'></span></span>" +
                "<span class='search-bar-button search-close active'><span class='icon-16 icon-close-white'></span></span>" +
                '</div>'
            )
          );
          var $searchBar = $container.find('.search-bar');
          $container.find('.search-toggler').click(function () {
            $searchBar.toggleClass('open');
            if ($searchBar.hasClass('open')) {
              $container.find('.photo-preview').css({ top: '55px' });
              $container.find('.search-bar input').focus();
            } else {
              $container.find('.photo-preview').css({ top: '' });
            }
          });

          $container.find('.search-bar input').keyup(function () {
            var $searchButton = $container.find('.search-bar .search-button');
            $searchButton.toggleClass('active', $(this).val() != '');
          });
        } else {
          $container.find('.search-toggler').remove();
        }

        // autohiding of images toolbox
        var $toolbox = $container.find('.plugin-tool-box');
        var $topRightPreview = $container.find('aside.photo-preview');
        hidePreviewControls($container, $toolbox, $topRightPreview);

        callback && callback();
      },

      load: function (data) {
        var pageControls = $container.find('.page-counter, .photos-more-toggle, #next-figure, #previous-figure');
        if (data.pages.length <= 1) {
          pageControls.remove();
        } else {
          pageControls.show();
        }
        if (!data.chapters || data.chapters.length == 0) {
          $container.find('#toggle-chapters').remove();
        } else {
          $container.find('#toggle-chapters').show();
        }

        loadScripts(['openseadragon.min.js'], loadData, typeof OpenSeadragon === 'undefined');

        function buildChapters(data, openseadragon) {
          if (!data.chapters) {
            return;
          }
          var $chapterContainer = $("<div class='clearfix chapter-collection clearfix' />");
          $container.find('#chapters').find('.container').append($chapterContainer);
          addChapters(data.chapters);

          function addChapters(chapters) {
            var pageIndex = 0;
            for (i = 0; i < chapters.length; i++) {
              var chapter = chapters[i];
              $chapterContainer.append(
                $("<div class='chapter-title uppercase white' />")
                  .addClass('chapter-' + i)
                  .text(chapters[i].title)
              );
              for (p = 0; p < chapter.pages.length; p++) {
                var page = chapter.pages[p];
                var $pageImage = $('<img class="chapter-page" />').attr('data-src', page.thumbnail.url);
                var $pageLink = $('<a />')
                  .attr('data-page', pageIndex++)
                  .append($pageImage);
                $pageLink.click(function () {
                  openseadragon.goToPage($(this).data('page'));
                  $container.find('.icon-eye-white').click();
                });
                $chapterContainer.append($pageLink);
              }
            }
          }

          function addDropdown(chapters) {
            var $header = $container.find('header');
            $header.append($("<span class='spacer white' />").text('|'));
            var $chapterHolder = $("<div class='chapter-holder' />");
            $chapterHolder.html(
              '<a href="#" class="uppercase white chapters-list-toggle">Kapitoly<span class="icon-16 icon-arrow-down-white"></span></a>'
            );
            var $chapterList = $("<ul class='chapters-list hidden' />");
            $chapterHolder.append($chapterList);

            for (i = 0; i < chapters.length; i++) {
              var $chapterLink = $('<a class="uppercase white" />').attr('data-chapter', i).text(chapters[i].title);
              $chapterList.append($('<li />').append($chapterLink));
              $chapterLink.click(function () {
                var $chapterTitle = $container.find('.chapter-' + $(this).data('chapter'));
                $container.find('.chapter-section').animate(
                  {
                    scrollTop: $chapterTitle.offset().top + $container.find('.chapter-section').scrollTop() - 60,
                  },
                  config.animationSpeed
                );
              });
            }
            $header.append($chapterHolder);
            $chapterHolder.find('a').click(function () {
              $chapterList.toggleClass('hidden');
            });
          }

          addDropdown(data.chapters);
        }

        function loadData() {
          var loadThumbs = true;
          // select tile sources from data
          var getTileSources = function () {
            var result = [];
            data.pages.forEach(function (item, index) {
              result.push(item.fullPage.iiifUrl);
            });
            return result;
          };

          function getInitalPage() {
            var page = getParameter(config.urlParameters.page, 1) - 1;
            if (page) {
              return page;
            }
            page = getCookie(pageCookieName());
            if (page) {
              return page - 1;
            }
            return 0;
          }

          var containerId = 'osd-' + guid();

          //opensadragon i18n update
          OpenSeadragon.setString('Tooltips.Home', Liferay.Language.get('openseadragon.tooltips.tooltips.Home'));
          OpenSeadragon.setString('Tooltips.FullPage', Liferay.Language.get('openseadragon.tooltips.FullPage'));
          OpenSeadragon.setString('Tooltips.Home', Liferay.Language.get('openseadragon.tooltips.Home'));
          OpenSeadragon.setString('Tooltips.ZoomIn', Liferay.Language.get('openseadragon.tooltips.ZoomIn'));
          OpenSeadragon.setString('Tooltips.ZoomOut', Liferay.Language.get('openseadragon.tooltips.ZoomOut'));
          OpenSeadragon.setString('Tooltips.NextPage', Liferay.Language.get('openseadragon.tooltips.NextPage'));
          OpenSeadragon.setString('Tooltips.PreviousPage', Liferay.Language.get('openseadragon.tooltips.PreviousPage'));
          OpenSeadragon.setString('Tooltips.RotateLeft', Liferay.Language.get('openseadragon.tooltips.RotateLeft'));
          OpenSeadragon.setString('Tooltips.RotateRight', Liferay.Language.get('openseadragon.tooltips.RotateRight'));

          OpenSeadragon.setString('Errors.Dzc', Liferay.Language.get('openseadragon.errors.Dzc'));
          OpenSeadragon.setString('Errors.Dzi', Liferay.Language.get('openseadragon.errors.Dzi'));
          OpenSeadragon.setString('Errors.Xml', Liferay.Language.get('openseadragon.errors.Xml'));
          OpenSeadragon.setString('Errors.ImageFormat', Liferay.Language.get('openseadragon.errors.ImageFormat'));
          OpenSeadragon.setString('Errors.Security', Liferay.Language.get('openseadragon.errors.Security'));
          OpenSeadragon.setString('Errors.Status', Liferay.Language.get('openseadragon.errors.Status'));
          OpenSeadragon.setString('Errors.OpenFailed', Liferay.Language.get('openseadragon.errors.OpenFailed'));

          $container.find('.openseadragon-outer-container').attr('id', containerId);

          // initialize openseadragon
          var openseadragon = OpenSeadragon({
            id: containerId,
            tileSources: getTileSources(),
            showNavigator: true,
            sequenceMode: true,
            navigatorId: 'navigatorDiv',
            zoomInButton: 'zoom-in',
            zoomOutButton: 'zoom-out',
            homeButton: 'zoom-home',
            nextButton: 'next-figure',
            previousButton: 'previous-figure',
            showFullPageControl: false,
            initialPage: getInitalPage(),
            visibilityRatio: 0.9,
            crossOriginPolicy: config.crossOriginPolicy,
            ajaxWithCredentials: config.ajaxWithCredentials,
            loadTilesWithAjax: config.loadTilesWithAjax,
          });
          openseadragon.addHandler('open-failed', function () {
            removeLoader($container);
            addLoader($container, config.localization.errorRenderingView);
            $container.find('.plugin-tool-box.ko, .photo-preview').fadeOut();
          });
          openseadragon.addHandler('open', function () {
            removeLoader($container);
            setPhotoThumbnailSelected(openseadragon.currentPage());
          });

          // update page counter value
          $container.find('.page-counter').text(data.pages[openseadragon.currentPage()].label);

          $container.find('.search-bar .search-button').click(function () {
            addLoader($container);
            currentQuery = $container.find('.search-bar input').val();
            if (!currentQuery) {
              return;
            }
            config.searchFunction(currentQuery, function (response) {
              showSearchResults(response.searchResult);
              currentSearchResult = response.searchResult;
              currentSearchIndex = 0;
              if (response == '' || response.searchResult == undefined || response.searchResult.length == 0) {
                changeLoaderText($container, config.localization.notFound);
                removeLoader($container, 1500);
              } else {
                removeLoader($container);
              }
            });
          });

          if (getParameter('search')) {
            $container.find('.search-bar input').val(getParameter('search'));
            $container.find('.search-toggler').click();
            $container.find('.search-bar .search-button').click();
          }

          $container.find('.search-bar input').keyup(function (e) {
            if (e.keyCode == 13) {
              if (currentQuery == $(this).val()) {
                $container.find('.search-bar .search-next').click();
              } else {
                $container.find('.search-bar .search-button').click();
              }
            }
          });

          function clearSearchResults() {
            $container.find('.search-bar').removeClass('open');
            $container.find('.photo-preview').css({ top: '' });
            openseadragon.clearOverlays();
            currentSearchResult = [];
            currentSearchIndex = 0;
          }

          $container.find('.search-bar .search-close').click(function () {
            clearSearchResults();
          });

          function showSearchResults(searchData, page) {
            if (!searchData) {
              return;
            }
            openseadragon.clearOverlays();
            if (!page) {
              var pages = [];
              for (i = 0; i < searchData.length; i++) {
                pages.push(searchData[i].page);
              }
              var page = Math.min.apply(null, pages);
              if (page != openseadragon.currentPage()) {
                openseadragon.goToPage(page);
              }
            }
            for (i = 0; i < searchData.length; i++) {
              var search = searchData[i];
              if (openseadragon.currentPage() == search.page) {
                var iiifUrl = data.pages[search.page]['fullPage']['iiifUrl'];
                var iiifData = {};

                $.ajax({
                  url: iiifUrl,
                  crossDomain: true,
                  success: function (ret) {
                    iiifData = ret;
                  },
                  async: false,
                });
                var originWidth = iiifData['width'];
                var originHeight = iiifData['height'];
                $(elt).attr('data-search-index', i);
                for (var o = 0; o < search.overlays.length; o++) {
                  var elt = document.createElement('div');
                  elt.className = 'search-result-rect';
                  $(elt).attr('data-index', i);
                  var overlay = search.overlays[o];
                  //prepocet suradnic na hodnotu 0..1 (prepocet podla povodnej velkosti obrazka)
                  var x = 1 / (originWidth / overlay.x);
                  var y = 1 / (originHeight / openseadragon.viewport.contentAspectY / overlay.y); // chyba v openseadragon .. Y-novu suradnicu zobrazuje len na 66 percent hodnoty
                  var w = 1 / (originWidth / overlay.width);
                  var h = 1 / (originHeight / openseadragon.viewport.contentAspectY / overlay.height); // chyba v openseadragon .. Y-novu suradnicu zobrazuje len na 66 percent hodnoty
                  $(elt).data('point', new OpenSeadragon.Point(x, y));
                  openseadragon.addOverlay({
                    element: elt,
                    location: new OpenSeadragon.Rect(x, y, w, h),
                  });
                }
                if (currentSearchIndex == i) {
                  var overlay = null;
                  if (nextDirection) {
                    overlay = $(openseadragon.currentOverlays[0].element);
                  } else {
                    overlay = $(openseadragon.currentOverlays[openseadragon.currentOverlays.length - 1].element);
                  }
                  var si = $(overlay).data('index');
                  setOverlayActive(si);
                  updateNextPrevButtons(searchData);
                }
              }
            }
          }

          function setOverlayActive(index) {
            $('.search-result-rect').removeClass('active');
            $('[data-index="' + index + '"]').addClass('active');
            if ($('[data-index="' + index + '"]').length) {
              var point = $($('[data-index="' + index + '"]')[0]).data('point');
              openseadragon.viewport.panTo(point);
              openseadragon.viewport.zoomTo(openseadragon.viewport.getMinZoom() * 2);
            }
          }

          function nextSearchResult() {
            var nextSearchWord = currentSearchResult[currentSearchIndex + 1];
            if (!nextSearchWord) {
              return;
            }
            if (openseadragon.currentPage() != nextSearchWord.page) {
              nextDirection = true;
              currentSearchIndex++;
              updateNextPrevButtons();
              openseadragon.goToPage(nextSearchWord.page);
            } else {
              currentSearchIndex++;
              updateNextPrevButtons();
              setOverlayActive(currentSearchIndex);
            }
          }

          function updateNextPrevButtons(searchData) {
            if (!searchData) {
              searchData = currentSearchResult;
            }
            $container.find('.search-bar .search-prev').toggleClass('active', currentSearchIndex > 0);
            $container
              .find('.search-bar .search-next')
              .toggleClass('active', currentSearchIndex < searchData.length - 1);
          }

          function prevSearchResult() {
            var prevSearchWord = currentSearchResult[currentSearchIndex - 1];
            if (!prevSearchWord) {
              return;
            }

            if (openseadragon.currentPage() != prevSearchWord.page) {
              nextDirection = false;
              currentSearchIndex--;
              updateNextPrevButtons();
              openseadragon.goToPage(prevSearchWord.page);
            } else {
              currentSearchIndex--;
              updateNextPrevButtons();
              setOverlayActive(currentSearchIndex);
            }
          }

          $container.find('.search-bar .search-next').click(function () {
            nextSearchResult();
          });

          $container.find('.search-bar .search-prev').click(function () {
            prevSearchResult();
          });

          function pageCookieName() {
            return (
              'page-' +
              getParameter(config.urlParameters.contentId) +
              '-' +
              getParameter(config.urlParameters.contentDo)
            );
          }

          var pageHandler = function (event) {
            $container.find('.page-counter').text(data.pages[event.page].label);

            setParameter(config.urlParameters.page, '' + (event.page + 1), true);
            setCookie(pageCookieName(), event.page + 1, 30);
            setTimeout(function () {
              showSearchResults(currentSearchResult, '' + event.page);
            }, 200);
          };

          // handler for updating page URL parameter when page changed
          openseadragon.addHandler('page', pageHandler);

          // bind fullscreen events
          $container.find('.icon-extend-white').click(function () {
            if (!isInFullscreen()) {
              requestFullscreen($container.get(0));
              setTimeout(function () {
                loadThumbnailImagesImmediately();
              }, 800);
            } else {
              exitFullscreen($container.get(0));
            }
          });

          // build pages thumbnails bar
          var $thumbnailsHolder = $container.find('.photo-thumbnails-viewport');

          // to quickly load and show page, others will come later (open event?)
          var $firstImageUrl = data.pages[0].thumbnail.url;
          var $firstImageAlt = data.pages[0].thumbnail.alt;

          data.pages.forEach(function (page, index) {
            var image = $('<img  class="lazy" />')
              .attr('data-src', page.thumbnail.url)
              .attr('alt', $firstImageAlt)
              .attr('data-index', index);

            if (isBook) {
              //use book label as page number
              var counter = $(
                "<div class='text-center white thumbnail-table-preview' style='width:35px !important;' title='" +
                  page.label +
                  "' />"
              ).text(page.label);
            } else {
              var counter = $("<div class='show-as-row text-center white' />").text(index + 1);
            }
            $thumbnailsHolder.append(
              $("<div class='thumbnail-table' />")
                .append($("<div class='show-as-row' />").append(image))
                .append(counter)
            );
          });

          // ... and bind click events to page thumbnails and
          // thumbnail bar toggler
          $('.photo-thumbnails-holder .photo-thumbnails-viewport .thumbnail-table img').each(function (index, element) {
            $(element).click(function () {
              openseadragon.goToPage(index);
            });
          });

          function setPhotoThumbnailSelected(page) {
            $('.photo-thumbnails-holder .photo-thumbnails-viewport .thumbnail-table img').removeClass('selected');
            var image = $('.photo-thumbnails-viewport .thumbnail-table img[data-index="' + page + '"]');
            if (image) {
              image.addClass('selected');
              scrollToItem(image, page);
            }
          }

          var LoadingImages = {
            allCount: 0,
            loadedCount: 0,

            addImage: function () {
              this.allCount++;
            },
            setImageDone: function () {
              this.loadedCount++;
            },
            isAllDone: function () {
              if (this.allCount > 1 && this.allCount == this.loadedCount) {
                return true;
              }
              return false;
            },
          };

          function loadThumbnailImages() {
            var $thumbnailsHolderIn = $container.find('.photo-thumbnails-holder');

            //sroller must stop to load
            $('.photo-thumbnails-holder .photo-thumbnails-viewport').scroll(function () {
              clearTimeout($.data(this, 'scrollTimer'));

              $.data(
                this,
                'scrollTimer',
                setTimeout(function () {
                  // do something
                  loadThumbnailImagesImmediately();
                }, 250)
              );
            });
          }

          function loadThumbnailImagesImmediately() {
            var $thumbnailsHolderIn = $container.find('.photo-thumbnails-holder');
            //sroller must stop to load
            // do something
            var page = null;
            var lastPage;
            $('.photo-thumbnails-holder .photo-thumbnails-viewport img[data-src]').each(function (index, element) {
              //out off view port
              if ($(element).position().left > $('.photo-thumbnails-holder .photo-thumbnails-viewport').innerWidth()) {
                return false;
              }
              //in viewport
              if ($(element).position().left > 0) {
                if (page == null) {
                  page = $(element).attr('data-index');
                }
                lastPage = $(element).attr('data-index');
              }
            });

            //load next 15 elemnts
            if (parseInt(page) > -1) {
              for (var i = parseInt(page); i <= parseInt(lastPage) + 1; i++) {
                if (i < data.pages.length) {
                  var element = $('img.lazy[data-index=' + i + ']');
                  if (element.attr('data-src')) {
                    element.attr('src', element.attr('data-src'));
                    element.removeAttr('data-src');
                  }
                }
              }
            }
          }

          function scrollToItem(target, page) {
            var viewPort = $('.photo-thumbnails-holder .photo-thumbnails-viewport');
            offset = viewPort.width() / 2;
            var targetItem = target.parent().parent();

            if (viewPort) {
              $(viewPort).scrollTo(targetItem, { offset: { left: -offset }, axis: 'x' });
              loadThumbnailImagesImmediately();
            }
          }

          $container.find('.photos-more-toggle').click(function () {
            $thumbnailsHolder.parent().toggleClass('hidden');
            if ($thumbnailsHolder.parent().hasClass('hidden')) {
              $(this).removeClass('icon-close-white').addClass('icon-thumbs-white');
              $(this).attr('title', Liferay.Language.get('plugin.more'));
            } else {
              $(this).removeClass('icon-thumbs-white').addClass('icon-close-white');
              $(this).attr('title', Liferay.Language.get('plugin.hide'));
              setPhotoThumbnailSelected(openseadragon.currentPage());
              // open event would be nice, but not by firefox
              loadThumbnailImages();
            }
          });

          $container.find('.icon-copy-white').click(function () {
            if (!$.trim($container.find('#chapters').find('.container').html())) {
              buildChapters(data, openseadragon);
            }
            if ($container.find('.photos-more-toggle').hasClass('icon-close-white')) {
              $container.find('.photos-more-toggle').click();
            }
            clearSearchResults();
            $container
              .find(
                '.openseadragon-outer-container, .photo-preview, .plugin-tool-box.ko .center-block, .icon-copy-white, .icon-search-empty-white'
              )
              .finish()
              .fadeOut('fast', function () {
                $container.find('#chapters, .icon-eye-white, .chapter-holder, header .spacer').fadeIn();
              });
          });

          $container.find('.icon-eye-white').click(function () {
            $container
              .find('#chapters, .icon-eye-white, .chapter-holder, header .spacer')
              .finish()
              .fadeOut('fast', function () {
                $container
                  .find(
                    '.openseadragon-outer-container, .photo-preview, .plugin-tool-box.ko .center-block, .icon-copy-white, .icon-search-empty-white'
                  )
                  .fadeIn(function () {
                    openseadragon.forceRedraw();
                  });
              });
          });

          //change page by key up,down,left,right
          $(document).keydown(function (e) {
            switch (e.which) {
              case 37: // left
              case 38: // down
                openseadragon.goToPage(openseadragon.currentPage() - 1);
                e.preventDefault(); // prevent the default action (scroll / move caret)
                break;

              case 39: // right
              case 40: // up
                openseadragon.goToPage(openseadragon.currentPage() + 1);
                e.preventDefault(); // prevent the default action (scroll / move caret)
                break;
              default:
                return; // exit this handler for other keys
            }
          });

          var currentContentId = getParameter(config.urlParameters.contentId, 1);

          window.onpopstate = function (event) {
            var contentId = getParameter(config.urlParameters.contentId, 1);
            var newPage = getParameter(config.urlParameters.page, 1);

            if (typeof digitalObjectOpenPrezentationList[contentId] !== 'undefined' && currentContentId != contentId) {
              digitalObjectOpenPrezentationList[contentId](true);
            } else if (newPage && newPage - 1 != openseadragon.currentPage()) {
              openseadragon.removeHandler('page', pageHandler);
              openseadragon.goToPage(newPage - 1);

              setCookie(pageCookieName(), newPage, 30);
              openseadragon.addHandler('page', pageHandler);
            }
          };
        }
      },
    };
  };

  var ObjectPanoramaPreview = function (container) {
    var $container = $(config.container);
    var side = getParameter(config.urlParameters.page, 1);

    return {
      render: function (callback) {
        $container.html(config.panoramaTemplate);
        addLoader($container);
        // $container.find(".toggle-side").text(config.localization.changeSide); - pridavalo text k buttonu ktory zatial neviem k comu sluzi
        // $container.find(".toggle-side").show();
        // embed panel
        if (config.enableEmbedding) {
          createEmbedPanel($container, getEmbedLink());
        } else {
          var $embedLink = $container.find('.icon-embed-white');
          $embedLink.hide();
        }

        //autohiding of panorama toolbox
        var $toolbox = $container.find('.plugin-tool-box');
        var $topRightPreview = $container.find('.panorama-navigator');
        hidePreviewControls($container, $toolbox, $topRightPreview);

        callback && callback();
      },

      load: function (data) {
        loadScripts(
          ['object2vr-player.min.js', 'object2vr.skin.min.js'],
          loadData,
          typeof object2vrPlayer === 'undefined'
        );

        function loadData() {
          var txt = data.xmlData;
          var parser = new DOMParser(); // tu som pridal "var"
          var xmlDoc = parser.parseFromString(txt, 'text/xml'); // tu som pridal "var"
          var objectPanoramaPlayer = new object2vrPlayer($container.find('#panorama-container').attr('id'));
          // skin = new object2vrSkin(objectPanoramaPlayer,
          // "/static/object2vr_mince/");
          objectPanoramaPlayer.readConfigXml(xmlDoc);

          if (side != 1) {
            objectPanoramaPlayer.changeViewState('' + (side - 1), 0);
          }

          rebindFullscreenEvents(function () {
            toggleFullscreenClass($container);
            objectPanoramaPlayer.setFullscreen(isInFullscreen());
          });

          // bind fullscreen events
          $container.find('.icon-extend-white').click(function () {
            if (!isInFullscreen()) {
              requestFullscreen($container.get(0));
            } else {
              exitFullscreen($container.get(0));
            }
          });

          if (data.doubleSided) {
            $container
              .find('.toggle-side')
              .removeClass('hidden')
              .click(function () {
                if (side == 1) {
                  side = 2;
                  setParameter(config.urlParameters.page, '2');
                } else {
                  side = 1;
                  removeParameter(config.urlParameters.page);
                }
                objectPanoramaPlayer.changeViewState('' + (side - 1), 0);
              });
          }
          var intervalID = setInterval(function () {
            if (objectPanoramaPlayer.isLoaded) {
              removeLoader($container);
              bindNavigatorEvents(objectPanoramaPlayer);
              clearInterval(intervalID);
            }
          }, 100);

          function bindNavigatorEvents(player) {
            var $navigator = $container.find('.panorama-navigator');
            simpleEvent($navigator.find('.button-up'), function () {
              player.changeTiltLog(1, true);
            });
            simpleEvent($navigator.find('.button-down'), function () {
              player.changeTiltLog(-1, true);
            });
            simpleEvent($navigator.find('.button-left'), function () {
              player.changePanLog(1, true);
            });
            simpleEvent($navigator.find('.button-right'), function () {
              player.changePanLog(-1, true);
            });
            simpleEvent($navigator.find('#zoom-in'), function () {
              player.changeFovLog(-15, true);
            });
            simpleEvent($navigator.find('#zoom-out'), function () {
              player.changeFovLog(15, true);
            });
            $navigator.find('#zoom-home').click(function () {
              player.changeFovLog(100, true);
            });
          }
        }
      },
    };
  };

  var SphericalPanoramaPreview = function (container) {
    var $container = $(config.container);

    return {
      render: function (callback) {
        $container.html(config.panoramaTemplate);
        addLoader($container);

        // bind fullscreen events
        $container.find('.icon-extend-white').click(function () {
          if (!isInFullscreen()) {
            requestFullscreen($container.get(0));
          } else {
            exitFullscreen($container.get(0));
          }
        });
        // embed panel
        if (config.enableEmbedding) {
          createEmbedPanel($container, getEmbedLink());
        } else {
          var $embedLink = $container.find('.icon-embed-white');
          $embedLink.hide();
        }

        //autohiding of spherical pano toolbox
        var $toolbox = $container.find('.plugin-tool-box');
        var $topRightPreview = $container.find('.panorama-navigator');
        hidePreviewControls($container, $toolbox, $topRightPreview);

        callback && callback();
      },

      load: function (data) {
        loadScripts(['./pano2vr.swfobject.js', './pano2vr-player.js'], loadData, typeof pano2vrPlayer === 'undefined');
        var sphericalPanoramaPlayer;

        function loadData() {
          var txt = data.xmlData; // tu som pridal "var"
          var parser = new DOMParser(); // tu som pridal "var"
          var xmlDoc = parser.parseFromString(txt, 'text/xml'); // tu som pridal "var"

          if (ggHasHtml5Css3D() || ggHasWebGL()) {
            // create the panorama player with the container
            sphericalPanoramaPlayer = new pano2vrPlayer($container.find('#panorama-container').attr('id'));
            sphericalPanoramaPlayer.readConfigXml(xmlDoc);
          } else if (swfobject.hasFlashPlayerVersion('10.0.0')) {
            var flashvars = {};
            var params = {};
            // enable javascript interface
            flashvars.externalinterface = '1';
            params.quality = 'high';
            params.bgcolor = '#ffffff';
            params.allowscriptaccess = 'sameDomain';
            params.allowfullscreen = 'true';
            var attributes = {};
            attributes.id = 'pano';
            attributes.name = 'pano';
            attributes.align = 'middle';
            flashvars.panoxml = xmlDoc; //"/static/pano2vr/panorama_cerin_out.xml";
            params.base = '.';
            swfobject.embedSWF(
              '/static/pano2vr/pano2vr_player.swf',
              $container.find('#panorama-container').attr('id'),
              '100%',
              'auto',
              '9.0.0',
              '',
              flashvars,
              params,
              attributes
            );
          }
          var intervalID = setInterval(function () {
            if (sphericalPanoramaPlayer.isLoaded) {
              removeLoader($container);
              bindNavigatorEvents(sphericalPanoramaPlayer);
              $container.find('.toggle-rotation').fadeIn();
              clearInterval(intervalID);
            }
          }, 100);

          function bindNavigatorEvents(player) {
            $container.find('.toggle-rotation').click(function () {
              player.toggleAutorotate();
              $(this).toggleClass('selected');
            });
            var $navigator = $container.find('.panorama-navigator');
            timedEvent($navigator.find('.button-up'), function () {
              player.changeTiltLog(1, true);
            });
            timedEvent($navigator.find('.button-down'), function () {
              player.changeTiltLog(-1, true);
            });
            timedEvent($navigator.find('.button-left'), function () {
              player.changePanLog(1, true);
            });
            timedEvent($navigator.find('.button-right'), function () {
              player.changePanLog(-1, true);
            });
            timedEvent($navigator.find('#zoom-in'), function () {
              player.changeFovLog(-1, true);
            });
            timedEvent($navigator.find('#zoom-out'), function () {
              player.changeFovLog(1, true);
            });
            $navigator.find('#zoom-home').click(function () {
              player.changeFovLog(100, true);
            });
          }
        }

        rebindFullscreenEvents(function () {
          toggleFullscreenClass($container);
          sphericalPanoramaPlayer.setFullscreen(isInFullscreen());
        });
      },
    };
  };

  var X3DPreview = function (container) {
    var $container = $(config.container);

    return {
      render: function (callback) {
        $container.html(config.x3dTemplate);
        addLoader($container);
        rebindFullscreenEvents(function () {
          if (isInFullscreen()) {
            $('x3d').css({
              height: $(window).height() + 8 + 'px',
            });
            x3dom.reload();
          } else {
            if (config.embedMode) {
              $('x3d').css({
                height: $(window).height() - 134 + 'px',
              });
            } else {
              $('x3d').css({
                height: '',
              });
            }
            x3dom.reload();
          }
          toggleFullscreenClass($container);
        });

        // bind fullscreen events
        $container.find('.icon-extend-white').click(function () {
          if (!isInFullscreen()) {
            requestFullscreen($container.get(0));
          } else {
            exitFullscreen($container.get(0));
          }
        });

        // embed panel
        if (config.enableEmbedding) {
          createEmbedPanel($container, getEmbedLink());
        } else {
          var $embedLink = $container.find('.icon-embed-white');
          $embedLink.hide();
        }

        $container
          .find('#reset-view')
          .click(function () {
            $('x3d').get(0).runtime.resetView();
          })
          .find('.caption')
          .text(config.localization.reset3D);
        $container
          .find('#view-everything')
          .click(function () {
            $('x3d').get(0).runtime.showAll();
          })
          .find('.caption')
          .text(config.localization.showAll3D);
        $container
          .find('#x3d-examine')
          .click(function () {
            $('x3d').get(0).runtime['examine']();
            $('.x3d-navigator #x3d-look-at').css({
              opacity: 0.5,
            });
            $(this).css({
              opacity: 1,
            });
          })
          .find('.caption')
          .text(config.localization.rotateObject);
        $container
          .find('#x3d-look-at')
          .click(function () {
            $('x3d').get(0).runtime['lookAt']();
            $('.x3d-navigator #x3d-examine').css({
              opacity: 0.5,
            });
            $(this).css({
              opacity: 1,
            });
          })
          .find('.caption')
          .text(config.localization.rotateView);

        //autohiding of 3D object toolbox and navigator
        /* var $toolbox = $container.find(".plugin-tool-box");
                var $topRightPreview = $container.find(".x3d-navigator");
                hidePreviewControls($container, $toolbox, $topRightPreview); */

        callback && callback();
      },

      load: function (data, callback) {
        loadScripts(['x3dom.css', 'x3dom.min.js'], loadData, typeof x3dom === 'undefined');

        function loadData() {
          x3dom.removeLoader = function () {
            removeLoader($container);
          };
          var sceneDom =
            '<X3D xmlns="http://www.web3d.org/specifications/x3d-namespace" id="inline" showStat="false" PrimitiveQuality="low" x="300px" y="300px">' +
            '<Scene>' +
            '<Inline onload="x3dom.removeLoader();" url="' +
            data.source.url +
            '"/></Scene></X3D>';
          $sceneContainer = $(container).find('.x3d-container');
          $sceneContainer.html(sceneDom);
          if (config.embedMode) {
            $('x3d').css({
              height: $(window).height() + 8 + 'px',
            });
          }

          x3dom.reload();
        }
      },
    };
  };

  return {
    resetParams: function (contentParam) {
      removeQueryString(['do', config.urlParameters.contentId, config.urlParameters.contentDo]);
    },

    unload: function () {
      //Stop video and clear video container.
      if (config.container.length) {
        $(config.container)
          .find('video')
          .each(function () {
            var elm = $(this);
            elm.get(0).pause();
            elm.src = '';
            elm.html('');
            elm.load();
            $(config.container).html('');
          });
      }
    },

    initialize: function (content, customConfig, historyRequest) {
      $.extend(true, config, customConfig);

      if (content.contentId) {
        setParameter(config.urlParameters.contentId, content.contentId, !historyRequest);
        setParameter(config.urlParameters.contentDo, content.contentDo, !historyRequest);
      }
      if (!historyRequest) {
        contentData = content;
      }
      window.onpopstate = function (event) {
        if (event.state && event.state.content) {
          Preview.initialize(event.state.content, config, true);
        }
      };

      var renderersMapping = {
        book: OpenSeaDragonPreview(config.container, true, true),
        images: OpenSeaDragonPreview(config.container, false, false),
        video: VideoPreview(config.container),
        audio: AudioPreview(config.container),
        objectPanorama: ObjectPanoramaPreview(config.container),
        '3D': X3DPreview(config.container),
        sphericalPanorama: SphericalPanoramaPreview(config.container),
      };

      var renderer = renderersMapping[content.type];
      $(config.container).fadeOut(config.animationSpeed, loadRenderer);
      function loadRenderer() {
        try {
          $(config.container).empty();
          renderer.render(function () {
            $(config.container).find('header').text(config.title);
            if (config.embedMode) {
              $('.icon-embed-white').remove();
            }
            //                        if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream){
            //                        	$('video').attr('controls', true);
            //                        }
            $(config.container).fadeIn(config.animationSpeed, function () {
              renderer.load(content.data);
              if (config.trackFunction) {
                config.trackFunction(content.contentDo, content.contentId, content.type);
              }
              $('html, body').animate(
                {
                  scrollTop: 0,
                },
                config.animationSpeed
              );
            });
          });
        } catch (error) {
          $(config.container)
            .empty()
            .append($("<div class='error-message' />").text(config.localization.errorRenderingView))
            .fadeIn(config.animationSpeed);
          console.error('Cannot render cultural object presentation: Cause: ' + error.message);
        }
      }

      $('body').on('contextmenu', '.openseadragon', function (e) {
        return false;
      });

      window.onpopstate = function (event) {
        var contentId = getParameter(config.urlParameters.contentId, 1);
        var newPage = getParameter(config.urlParameters.page, 1);

        if (typeof digitalObjectOpenPrezentationList[contentId] !== 'undefined') {
          digitalObjectOpenPrezentationList[contentId](true);
        }
      };
    },

    content_parameters: function () {
      return getParameter(config.urlParameters.contentId, 1);
    },
  };
};

// var Preview = new PreviewClass(jQuery);
const Preview = new PreviewClass(jQuery);
export default Preview;

const preparePanoramaXML = (preview) => {
  let prev = '';
  let tile = '';
  preview.sphericalPanorama.previewUrls.forEach((url, idx) => {
    prev += `prev${idx}url="${url}" `;
  });
  preview.sphericalPanorama.tileUrls.forEach((url, idx) => {
    prev += `tile${idx}url="${url}" `;
  });
  return `
        <panorama id="">
            <view fovmode="0" pannorth="0">
                ${`<start fov="${preview.sphericalPanorama.startView.fov}" pan="${preview.sphericalPanorama.startView.pan}" tilt="${preview.sphericalPanorama.startView.tilt}"/>`}
                ${`<min fov="${preview.sphericalPanorama.minView.fov}" pan="${preview.sphericalPanorama.minView.pan}" tilt="${preview.sphericalPanorama.minView.tilt}"/>`}
                ${`<max fov="${preview.sphericalPanorama.maxView.fov}" pan="${preview.sphericalPanorama.maxView.pan}" tilt="${preview.sphericalPanorama.maxView.tilt}"/>`}
            </view>
            <userdata
                author=""
                comment=""
                copyright=""
                datetime="2013:09:05 09:52:50"
                description=""
                info=""
                latitude=""
                longitude=""
                source=""
                tags=""
                title=""
            />
            <hotspots height="20" width="180" wordwrap="1">
                <label background="1" backgroundalpha="1" backgroundcolor="0xffffff" border="1" borderalpha="1" bordercolor="0x000000" borderradius="1" enabled="1" height="20" textalpha="1" textcolor="0x000000" width="180" wordwrap="1"/>
                <polystyle backgroundalpha="0.2509803921568627" backgroundcolor="0x0000ff" borderalpha="1" bordercolor="0x0000ff" mode="0"/>
            </hotspots>
            <media />
            <input
                ${prev}
                ${tile}
                tilescale="1.002754820936639"
                tilesize="3630"
            >
                <preview color="0x808080"/>
            </input>
            <control dblclickfullscreen="0" invertcontrol="1" invertwheel="1" lockedkeyboard="1" lockedmouse="0"
                lockedwheel="0" sensitivity="8" simulatemass="1" speedwheel="1"/>
        </panorama>
    `;
  /* `
        <panorama id="">
            <view fovmode="0" pannorth="0">
                <start fov="70.0" pan="0.0" tilt="0.0"/>
                <min fov="5.0" pan="-180.0" tilt="-85.0"/>
                <max fov="120.0" pan="180.0" tilt="85.0"/>
            </view>
            <userdata
                author=""
                comment=""
                copyright=""
                datetime="2013:09:05 09:52:50"
                description=""
                info=""
                latitude=""
                longitude=""
                source=""
                tags=""
                title=""
            />
            <hotspots height="20" width="180" wordwrap="1">
                <label background="1" backgroundalpha="1" backgroundcolor="0xffffff" border="1" borderalpha="1" bordercolor="0x000000" borderradius="1" enabled="1" height="20" textalpha="1" textcolor="0x000000" width="180" wordwrap="1"/>
                <polystyle backgroundalpha="0.2509803921568627" backgroundcolor="0x0000ff" borderalpha="1" bordercolor="0x0000ff" mode="0"/>
            </hotspots>
            <media />
            <input
                prev0url="https://content.slovakiana.sk/fileserver/public/${title}_preview_0.jpg"
                prev1url="https://content.slovakiana.sk/fileserver/public/${title}_preview_1.jpg"
                prev2url="https://content.slovakiana.sk/fileserver/public/${title}_preview_2.jpg"
                prev3url="https://content.slovakiana.sk/fileserver/public/${title}_preview_3.jpg"
                prev4url="https://content.slovakiana.sk/fileserver/public/${title}_preview_4.jpg"
                prev5url="https://content.slovakiana.sk/fileserver/public/${title}_preview_5.jpg"
                tile0url="https://content.slovakiana.sk/fileserver/public/${title}_0.jpg"
                tile1url="https://content.slovakiana.sk/fileserver/public/${title}_1.jpg"
                tile2url="https://content.slovakiana.sk/fileserver/public/${title}_2.jpg"
                tile3url="https://content.slovakiana.sk/fileserver/public/${title}_3.jpg"
                tile4url="https://content.slovakiana.sk/fileserver/public/${title}_4.jpg"
                tile5url="https://content.slovakiana.sk/fileserver/public/${title}_5.jpg"
                tilescale="1.002754820936639"
                tilesize="3630"
            >
                <preview color="0x808080"/>
            </input>
            <control dblclickfullscreen="0" invertcontrol="1" invertwheel="1" lockedkeyboard="0" lockedmouse="0"
                lockedwheel="0" sensitivity="8" simulatemass="1" speedwheel="1"/>
        </panorama>
    `; */
};

const prepareReversePanoramaXML = (data) => {
  let levels = '';
  data.levels.forEach((level) => {
    levels += `<level embed="0" height="${level.height}" predecode="0" preload="0" width="${level.width}"/> `;
  });

  return `
        <vrobject>
            <input
                columns="${data.columns}"
                fileextension="jpg"
                height="${data.height}"
                imagepath="images"
                levelbias="0.4000000059604645"
                levelmembmp="200"
                levelmemraw="300"
                levelqueuebmp="5"
                levelqueueraw="20"
                leveltilesize="${data.levelTileSize}"
                leveltileurl="${data.levelTileUrl}"
                overlap="${data.overlap}"
                preload="1"
                preview="4"
                rows="${data.rows}"
                states="${data.states}"
                width="${data.width}"
                windowheight="427"
                windowwidth="640"
            >
                <!--  levels -->
                ${levels}
            </input>
            <control automovemode="1" controller="1" dblclickfullscreen="0" invertwheel="1" lockedkeyboard="1" lockedmouse="0" lockedwheel="0" revx="0" revy="0" sensitivity="10" simulatemass="1" speedwheel="1" swapxy="0" trapwheel="1" wrapx="1" wrapy="0"/>
            <view>
                <start column="0" row="0" state="0"/>
                <zoom default="1" max="10" min="1"/>
                <viewer background="0" backgroundcolor="0xffffff" imagescaling="1"/>
            </view>
            <autorotate delay="5" speed="1" start="0"/>
            <userdata author="" comment="" copyright="" datetime="" description="" info="" source="" title=""/>
            <qthotspots enabled="0" reuse="8">
                <label background="1" backgroundalpha="1" backgroundcolor="0xffffff" border="1" borderalpha="1" bordercolor="0x000000" borderradius="1" enabled="1" height="20" textalpha="1" textcolor="0x000000" width="180" wordwrap="1"/>
            </qthotspots>
            <hotspots>
                <label background="1" backgroundalpha="1" backgroundcolor="0xffffff" border="1" borderalpha="1" bordercolor="0x000000" borderradius="1" enabled="1" height="20" textalpha="1" textcolor="0x000000" width="180" wordwrap="1"/>
                <polystyle backgroundalpha="0.2509803921568627" backgroundcolor="0x0000ff" borderalpha="1" bordercolor="0x0000ff" mode="0"/>
            </hotspots>
        </vrobject>
    `;
};

export { preparePanoramaXML, prepareReversePanoramaXML };
